import { render, staticRenderFns } from "./addProductModel.vue?vue&type=template&id=6bec736e&scoped=true"
import script from "./addProductModel.vue?vue&type=script&lang=js"
export * from "./addProductModel.vue?vue&type=script&lang=js"
import style0 from "./addProductModel.vue?vue&type=style&index=0&id=6bec736e&prod&scoped=true&lang=css"
import style1 from "./addProductModel.vue?vue&type=style&index=1&id=6bec736e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec736e",
  null
  
)

export default component.exports